import React from 'react';
import { Dialog, Box, DialogTitle, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Available colors for tiles
const TILE_COLORS = [
    '#ffffff', // White
    '#f5f5f5', // Light Gray
    '#e3f2fd', // Light Blue
    '#e8f5e9', // Light Green
    '#fff3e0', // Light Orange
    '#fce4ec', // Light Pink
    '#f3e5f5', // Light Purple
    '#fffde7', // Light Yellow
    '#e0f2f1', // Light Teal
    '#fbe9e7', // Light Deep Orange
    '#e1f5fe', // Lighter Blue
    '#f1f8e9', // Lighter Green
];

function ColorPickerPopup({ open, onClose, currentColor, onColorSelect }) {
    const { t } = useTranslation();

    const handleColorClick = (color) => {
        onColorSelect(color);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                }
            }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                {t('common.selectColor')}
                <IconButton size="small" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Box sx={{ p: 3, pt: 1 }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, 1fr)',
                    gap: 1.5,
                }}>
                    {TILE_COLORS.map((color) => (
                        <Box
                            key={color}
                            onClick={() => handleColorClick(color)}
                            sx={{
                                width: 40,
                                height: 40,
                                backgroundColor: color,
                                border: currentColor === color ? '3px solid #1976d2' : '1px solid #ddd',
                                borderRadius: 1,
                                cursor: 'pointer',
                                transition: 'transform 0.1s ease-in-out',
                                '&:hover': {
                                    transform: 'scale(1.15)',
                                    boxShadow: 2,
                                },
                            }}
                        />
                    ))}
                </Box>
            </Box>
        </Dialog>
    );
}

export default ColorPickerPopup;
